angular.module('gym.components').directive('signedWaiverHeader', function() {
  return {
    restrict: 'EA',
    scope: {
      waiver: '='
    },
    template: require('templates/components/waivers/signed_waiver_header.html.slim')
  };
});
